import axios from "axios";
import Cookies from "js-cookie";

const api = axios.create({ baseURL: "https://api-legado.barbeariagalloman.com.br" });
// const api = axios.create({ baseURL: "http://172.173.174.106:8080" });

api.interceptors.request.use(
  config => {
    config.headers["Authorization"] = "bearer " + Cookies.get("rui-auth-token");
    return config;
  },
  error => {
    Promise.reject(error);
  },
);

export default api;
